import { IonRouterLink } from '@ionic/react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import BasicCard from '@components/cards/BasicCard';
import DocumentPopover from '@components/drive/DocumentPopover';
import styles from '@components/drive/Drive.module.css';
import BodyCopyBold from '@components/typography/BodyCopyBold';
import { FileResourceFragment, GetJourneyWithDocumentsQuery } from '@typing/Generated';
import { getFileImage } from '@utils/fileUtils';
import { imageUrl } from '@utils/imageUtils';
import { getFileResourceTitle } from '@utils/modelUtils';

type Props = {
  fileResource: FileResourceFragment;
  handlePreviewFileResource: (fileResource: FileResourceFragment) => void;
  journey: GetJourneyWithDocumentsQuery['journey'];
};

const Document = ({ fileResource, handlePreviewFileResource, journey }: Props) => {
  const intl = useIntl();

  const previewFile = useCallback(() => {
    if (fileResource.attachment?.scanning === false) {
      handlePreviewFileResource(fileResource);
    }
  }, [fileResource, handlePreviewFileResource]);

  return (
    <IonRouterLink className={fileResource.attachment?.scanning ? styles.disabledDoc : ''} onClick={previewFile}>
      <BasicCard key={fileResource.id}>
        <div className={styles.headerRecentFile}>
          <div>
            <img
              aria-label={intl.formatMessage({ id: 'accessibility.ariaLabels.file' })}
              className={styles.headerFileImg}
              src={imageUrl(getFileImage(fileResource))}
            />
            <div className={styles.headerFileTitle}>
              <BodyCopyBold color="neutral500">{getFileResourceTitle(fileResource, intl)}</BodyCopyBold>
            </div>
          </div>
          <DocumentPopover fileResource={fileResource} journey={journey} />
        </div>
      </BasicCard>
    </IonRouterLink>
  );
};

export default Document;
